import styled from "styled-components";
import { ModalRadioItem } from "styles/ModalRadioCommonStyled";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";

export const RadioItem = styled(ModalRadioItem)<{ $iconColor: string }>`
  position: relative;
  padding: 20px 40px 20px 20px;
  gap: 20px;
  background-color: ${({ theme }) => theme.COLORS.SIDEBARBG};
  border: 1px solid
    ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.LIGHTGRAYBORDER
        : theme.COLORS.BORDER};
  .item-link {
    font-size: ${calcRem(12)};
    font-weight: 500;
    padding-top: 15px;
    color: ${({ theme, checked }) =>
      checked ? theme.COLORS.SELECTED : theme.COLORS.TEXT};
    text-transform: uppercase;
    svg {
      vertical-align: middle;
    }
  }
  .radio-item-checked-icon {
    background-color: ${({ $iconColor }) => $iconColor};
  }

  .report-radio-item {
    font-size: ${calcRem(17)};
    ${FLEX.FlexStartCenter};
    gap: 10px;
  }
  .firmware-upgrade-status {
    font-size: ${calcRem(11)};
    text-transform: uppercase;
    font-weight: 500;

    color: ${COLORS.WHITE};
    background-color: ${({ theme }) => theme.COLORS.BUTTONS3};
    &.on {
      background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
    }
    padding: 2px 4px;
    border-radius: 4px;
  }
  .subtitle {
    font-size: ${calcRem(15)};
  }
  .arrow-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.5;
    font-size: ${calcRem(20)};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  @media (max-height: 700px) and (min-width: ${mediaQuery.mobileMax}px) {
    height: 100%;
  }
`;

export const ManagementWrapper = styled(InnerPaddingWrapper)`
  display: grid;
  grid-auto-rows: 1fr;
  gap: 10px;
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
  padding-top: 50px;
  .recorder-icon {
    width: 20px;
    height: 20px;
  }
`;
